/**
 * SejlStroem product data UI, adapted to Atelier 3.2.1's variant:update event.
 * Reuses the HTML the theme already fetched. No cart requests, polling, cookies,
 * external services, or new network requests. Product IDs stay strings.
 */
(() => {
  if (customElements.get('ss-product-facts')) return;
  class SsProductFacts extends HTMLElement {
    connectedCallback() {
      this.eventRoot = this.closest('product-card') || this.closest('dialog') || this.closest('.shopify-section');
      this.eventRoot?.addEventListener('variant:update', this.onVariantUpdate, true);
    }
    disconnectedCallback() {
      this.eventRoot?.removeEventListener('variant:update', this.onVariantUpdate, true);
    }
    onVariantUpdate = (event) => {
      const data = event.detail?.data;
      const html = data?.html;
      if (!html || typeof html.querySelectorAll !== 'function') return;
      const targetProductId = String(data.newProduct?.id || data.productId || event.target?.dataset?.productId || '');
      const currentProductId = this.dataset.productId;
      if (targetProductId !== currentProductId) return;
      // A nested accessory card's data must never follow the main product variant.
      const candidates = html.querySelectorAll('ss-product-facts');
      const source = Array.from(candidates).find((element) =>
        element.dataset.ssKind === this.dataset.ssKind &&
        element.dataset.productId === currentProductId
      );
      if (!source) {
        // Never keep a compatibility claim for a variant whose markup is absent.
        this.hidden = true;
        return;
      }
      const openGroups = new Map(Array.from(this.querySelectorAll(':scope > .ss-relations__inner > details'))
        .map((group) => [group.dataset.ssGroup, group.open]));
      this.replaceChildren(...Array.from(source.childNodes, (node) => node.cloneNode(true)));
      this.hidden = source.hidden;
      this.querySelectorAll(':scope > .ss-relations__inner > details').forEach((group) => {
        if (openGroups.has(group.dataset.ssGroup)) group.open = openGroups.get(group.dataset.ssGroup);
      });
    };
  }
  customElements.define('ss-product-facts', SsProductFacts);
})();
